import 'primeicons/primeicons.css';
import 'typeface-roboto';
import 'typeface-inter';
//import 'typeface-montserrat';
import '../node_modules/font-awesome/css/font-awesome.css';
import '../node_modules/primereact/resources/primereact.min.css';

import 'bz-utilities/global';

import { Provider, observer } from 'mobx-react';
import React, { Component, lazy } from 'react';
import { Toaster } from 'react-hot-toast';
import { Route, Router, Switch } from 'react-router-dom';

import MomentUtils from '@date-io/moment';

import { MuiThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import LoadingPanel from 'bz-core-controls/controls/layout/loading-panel';
import LazyWrapper from 'bz-core-controls/controls/lazy';
import TerminalDialogWrapper from 'bz-core-controls/controls/payments/shared/terminal-payment-dialog/terminal-dialog-wrapper';
import BzErrorsInitialiser from 'bz-core-controls/errors/controls/initialiser';
import theme from 'bz-core-controls/styles/mui-next-theme';
import Theme from 'bz-core-controls/styles/theme';

import { Register as BzIconsRegister } from 'bz-icons';

import { OldReportView } from 'bz-reports/reports/bespoke/view';

import AuthStore, { AuthStoreContext } from 'bz-stores/lib/auth-store';

import LocalStorageHack from 'bz-utilities/controls/db-upgrade';
import { DictionaryStoreProvider } from 'bz-utilities/dictionary/dictionary-provider';
import history from 'bz-utilities/modules/networking/history/rr4';
import Register from 'bz-utilities/modules/plugins/register';
import VersionCheck from 'bz-utilities/modules/version-check';

import { CacheProvider } from 'tm3-core/cache';
import { cache } from 'tm3-core/cache';
import plugin from 'tm3-core/controls/plugin-util';
import VideoAppointment from 'tm3-core/controls/video-appointment';
import VideoStore from 'tm3-core/controls/video/store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AnalyticsProvider } from 'core/analytics';
import { RouteTracking } from 'core/analytics/june/context';
import { LoginRoutePaths } from 'core/auth';
import AuthPages from 'modules/auth';
import ModuleFeatureProvider from 'tm3-core/controls/module/provider';
import AuthenticatedControls from './controls/authenticated';
import License from './controls/license';
import PermissionsProvider from './controls/permissions';
import SquareProviderWrapper from './controls/square-provider-wrapper';
import StripeProviderWrapper from './controls/stripe-provider-wrapper';
import GlobalSubscriber from './controls/subscriber';
import NewUX from './shell/new-ux';
const AuthenticatedApp = LazyWrapper(lazy(() => import('./shell/app')));

const Print = LazyWrapper(lazy(() => import('./modules/print')));
const DiaryPrinting = LazyWrapper(lazy(() => import('./modules/diary/controls/printing-control')));
const DiaryListPrinting = LazyWrapper(
  lazy(() => import('./modules/diary/controls/printing-list-control'))
);
const ClinicalPrinting = LazyWrapper(lazy(() => import('bz-clinical/controls/print/print-page')));
const NotFoundWarning = LazyWrapper(lazy(() => import('./controls/not-found-warning')));
const ZoomLogin = LazyWrapper(lazy(() => import('./controls/zoom-login')));
const MyAccountInvoice = LazyWrapper(lazy(() => import('my-account/invoices/invoice')));
const FormPrint = LazyWrapper(lazy(() => import('./modules/contacts/print/forms')));
const ReportPrint = LazyWrapper(lazy(() => import('./modules/my-clinic/controls/print/report')));
const InvoicePrint = LazyWrapper(lazy(() => import('./modules/my-clinic/controls/print/invoice')));
const FileViewer = LazyWrapper(
  lazy(() => import('caseflow/src/workflow/workflow-view/tabs/documents/controls/file-viewer'))
);
const videoStore: VideoStore = new VideoStore();
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ApiNotifications from 'modules/controls/api-notifications';
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 30 /* 30 seconds */ } }
});

function setFavicon() {
  let icon;
  if (cache.app.Caseflow) {
    icon = '/favicon-caseflow.ico';
  } else if (cache.isEClinic) {
    icon = '/favicon-eclinic.png';
  } else if (cache.isGDS) {
    icon = '/favicon-gds.png';
  } else if (cache.isPPM) {
    icon = '/favicon-ppm.svg';
  } else {
    return;
  }

  const link: HTMLLinkElement =
    document.querySelector("link[rel*='icon']") ?? document.createElement('link');
  const { host, protocol } = window.location;
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = `${protocol}//${host}${icon}`;
}

class App extends Component {
  render() {
    setFavicon();

    let app: any[] = [];
    let authenticatedControls;
    if (AuthStore.authenticated) {
      authenticatedControls = <AuthenticatedControls />;
      app = [
        <Route path="/print/repx" component={OldReportView} />,
        <Route path="/printing/diary/list" component={DiaryListPrinting} />,
        <Route path="/printing/diary" component={DiaryPrinting} />,
        <Route path="/printing/cases/:id(\d+)" component={ClinicalPrinting} />,
        <Route path="/print/letter/:mode/:id(\d+)" component={Print} />,
        <Route path="/print/form/:id" component={FormPrint} />,
        <Route path="/print/report/:id" component={ReportPrint} />,
        <Route path="/print/invoice/:id" component={InvoicePrint} />,
        <Route path="/print/:mode/:params" component={Print} />,
        <Route path="/print/:mode" component={Print} />,
        <Route path="/my-account/invoice/:invoiceId" component={MyAccountInvoice} />,
        <Route path="/fileviewer/:filePath" component={FileViewer} />,

        React.Children.toArray(plugin('routes.appLevel', {}) || []),
        <Route path="/" component={AuthenticatedApp} />
      ];
    }

    return (
      <>
        <BzErrorsInitialiser />
        <LocalStorageHack />
        <Theme />
        <VersionCheck />
        <NewUX>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools buttonPosition="bottom-right" />
            <BzIconsRegister>
              <Register>
                <ModuleFeatureProvider authenticated={AuthStore.authenticated}>
                  <AuthStoreContext.Provider value={AuthStore}>
                    <Provider authStore={AuthStore} historyStore={history} videoStore={videoStore}>
                      <CacheProvider>
                        <DictionaryStoreProvider>
                          <StripeProviderWrapper>
                            <SquareProviderWrapper>
                              <GlobalSubscriber>
                                <License>
                                  <AnalyticsProvider>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                      <MuiThemeProvider theme={theme}>
                                        {/* <ZincProvider theme={tm3Theme}> */}
                                        <PermissionsProvider>
                                          <TerminalDialogWrapper>
                                            {authenticatedControls}
                                            <Toaster
                                              position="top-right"
                                              toastOptions={{
                                                success: { duration: 6000 },
                                                error: { duration: 8000 }
                                              }}
                                            />
                                            <ApiNotifications />
                                            <Router history={history.browserHistory}>
                                              <RouteTracking />
                                              <Switch>
                                                <Route path="/zoom" component={ZoomLogin} />
                                                <Route
                                                  path="/wrong-address"
                                                  component={NotFoundWarning}
                                                />
                                                <Route
                                                  path="/join/:videoId"
                                                  component={VideoAppointment}
                                                />
                                                <Route path="/join/" component={VideoAppointment} />
                                                <Route
                                                  path={LoginRoutePaths}
                                                  component={AuthPages}
                                                />

                                                {React.Children.toArray(app)}
                                                <Route component={AuthLoader} />
                                              </Switch>
                                            </Router>
                                          </TerminalDialogWrapper>
                                        </PermissionsProvider>
                                        {/* </ZincProvider> */}
                                      </MuiThemeProvider>
                                    </MuiPickersUtilsProvider>
                                  </AnalyticsProvider>
                                </License>
                              </GlobalSubscriber>
                            </SquareProviderWrapper>
                          </StripeProviderWrapper>
                        </DictionaryStoreProvider>
                      </CacheProvider>
                    </Provider>
                  </AuthStoreContext.Provider>
                </ModuleFeatureProvider>
              </Register>
            </BzIconsRegister>
          </QueryClientProvider>
        </NewUX>
      </>
    );
  }
}

const NoMatch = ({ location = {} }) => (
  <div>
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </div>
);

export default observer(App);

class AuthLoader extends React.Component {
  constructor(props) {
    super(props);
    AuthStore.checkLoginState();
  }
  render() {
    return <LoadingPanel />;
  }
}
